// src/pages/Shikshan.js
import React from "react";

export default function Shikshan() {
  const styles = {
    container: {
      padding: "28px",
      fontFamily: "'Noto Sans Devanagari', 'Mangal', sans-serif",
      color: "#222",
      background: "#fbfbfe",
      maxWidth: "1000px",
      margin: "20px auto",
      borderRadius: "10px",
      boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
      lineHeight: 1.75,
    },
    heading: {
      fontSize: "26px",
      fontWeight: 800,
      color: "#2c0f6b",
      marginBottom: "12px",
      textAlign: "left",
    },
    paragraph: {
      marginBottom: "12px",
      fontSize: "16px",
    },
    subHeading: {
      fontSize: "20px",
      fontWeight: 700,
      color: "#3b185f",
      marginTop: "18px",
      marginBottom: "8px",
    },
    list: {
      marginLeft: "20px",
      marginBottom: "10px",
      fontSize: "16px",
    },
    ulCompact: {
      marginLeft: "20px",
      marginBottom: "8px",
      fontSize: "15px",
    },
    note: {
      marginTop: "18px",
      fontWeight: 700,
      color: "#0b3b2e",
    },
    card: {
      background: "#fff",
      padding: "14px",
      borderRadius: "8px",
      boxShadow: "0 3px 10px rgba(10,10,10,0.04)",
      marginTop: "12px",
    },
    tableTitle: {
      fontWeight: 700,
      marginTop: "10px",
    },
    smallMuted: {
      fontSize: "14px",
      color: "#555",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>विभागाची प्रस्तावना</h2>

      <p style={styles.paragraph}>
        शिक्षण विभाग अंतर्गत समग्र शिक्षा (सर्व शिक्षा अभियान) ही केंद्र पुरस्कृत योजना आहे
        ज्यामध्ये केंद्राचे 60% व राज्याचे 40% अनुदान दिले जाते. समग्र शिक्षा अंतर्गत मोफत
        पाठ्यपुस्तके, मोफत गणवेश, वाहतूक सुविधा, अपंग मुलांच्या गरजा व विविध शैक्षणिक
        सुविधा शाळांना पुरवल्या जातात.
      </p>

      <p style={styles.paragraph}>
        या विभागाच्या माध्यमातून विद्यार्थ्यांच्या सर्वांगीण कल्याणासाठी गणवेश व लेखनसाहित्य वाटप,
        उपस्थिती भत्ता, शालेय पोषण आहार योजना व शिष्यवृत्ती यांसारख्या उपक्रम राबविले जातात.
      </p>

      <h3 style={styles.subHeading}>व्हिजन आणि मिशन</h3>
      <ul style={styles.list}>
        <li>पंचायत समिती अंतर्गत सर्व विद्यार्थ्यांना गुणवत्ता पूर्ण शिक्षण देणे.</li>
        <li>प्राथमिक शिक्षणाचा दर्जा उंचावून जीवनोपयोगी शिक्षण देणे.</li>
        <li>सर्व मुला-मुलींना प्राथमिक शिक्षण उपलब्ध करून देणे.</li>
      </ul>

      <h3 style={styles.subHeading}>उद्दिष्टे आणि कार्य</h3>
      <ul style={styles.list}>
        <li>विद्यालयातील विद्यार्थ्यांची गळती कमी करणे व १००% उपस्थिती साध्य करणे.</li>
        <li>६-१४ वयोगटातील शाळा न गेलेल्यांसाठी पर्यायी शिक्षण उपक्रम राबविणे.</li>
        <li>विशेष गरजा असलेल्या विद्यार्थ्यांना समान संधी उपलब्ध करणे.</li>
      </ul>

      <div style={styles.card}>
        <h4 style={{ ...styles.subHeading, marginTop: 0 }}>योजना (मुख्य)</h4>
        <ul style={styles.ulCompact}>
          <li>राष्ट्रीय आर्थिक शिष्यवृत्ती योजना</li>
          <li>भारतीय सैनिक महाविद्यालय शिष्यवृत्ती</li>
          <li>उच्च प्राथमिक व माध्यमिक शाळेतील शिष्यवृत्त्या (इ. 5–8)</li>
          <li>मोफत पाठ्यपुस्तक व गणवेश योजना</li>
          <li>उपस्थिती भत्ता योजना (इयत्ता 1–4 मुली)</li>
          <li>इयत्ता 10वी पर्यंत मोफत शिक्षण</li>
          <li>इयत्ता 11–12 फी माफी (वार्षिक उत्पन्न ≤ ₹1,00,000)</li>
          <li>नवभारत साक्षरता कार्यक्रम इत्यादी</li>
        </ul>
      </div>

      <h3 style={styles.subHeading}>जेष्ठता सूची</h3>
      <p style={styles.paragraph}>जेष्ठता सूची जिल्हा परिषद स्तरावर प्रकाशित केली जाते.</p>

      <h3 style={styles.subHeading}>अपिलीय / जनमाहिती अधिकारी</h3>
      <ul style={styles.list}>
        <li>प्रथम अपिलीय अधिकारी – गटशिक्षणाधिकारी पं.स. तुमसर – <span style={{fontWeight:700}}>8275397496</span></li>
        <li>जनमाहिती अधिकारी – कनिष्ठ प्रशासन अधिकारी – <span style={{fontWeight:700}}>9637256056</span></li>
      </ul>

      <h3 style={styles.subHeading}>इतर महत्वाचे</h3>

      <div style={styles.card}>
        <h4 style={styles.tableTitle}>१. राजीव गांधी विद्यार्थी अपघात सानुग्रह अनुदान योजना</h4>
        <p style={styles.paragraph}>
          इयत्ता 1 ते 12 पर्यंत शिकणाऱ्या विद्यार्थ्यांच्या अपघाती मृत्यू/अपंगत्वामुळे पालकांना आर्थिक
          सहाय्य दिले जाते.
        </p>
        <ul style={styles.ulCompact}>
          <li>अपघाती मृत्यू – ₹150,000</li>
          <li>कायम अपंगत्व (2 अवयव/2 डोळे) – ₹100,000</li>
          <li>एक अवयव/एक डोळा कायम निकामी – ₹75,000</li>
        </ul>
      </div>

      <div style={styles.card}>
        <h4 style={styles.tableTitle}>२. सावित्रीबाई फुले दत्तक पालक योजना</h4>
        <p style={styles.paragraph}>
          इयत्ता 1–8 मधील निराधार व आर्थिक दृष्ट्या दुर्बल मुलींसाठी आर्थिक मदत. प्रत्येक
          मुलीस प्रतिमाह ₹50 (वर्षभर ₹500) दिले जाते.
        </p>
      </div>

      <p style={styles.note}>
        अधिक माहितीसाठी: गटशिक्षणाधिकारी, पंचायत समिती तुमसर यांच्याशी संपर्क करा.
      </p>

      <p style={{ ...styles.smallMuted, marginTop: 12 }}>
        (हा भाग वेबसाईटसाठी सुलभ व वाचनयोग्य स्वरूपात दिला आहे — तुम्हाला हवा असल्यास
        मी हा घटक आणखी responsive किंवा Tailwind/CSS module वापरून सुधारून देऊ शकतो.)
      </p>
    </div>
  );
}
